import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { CertCreation } from "../components/CertCreation";

const CertificationCreateUpdateModal = ({
  visible,
  close,
  certList,
  cert,
  updateCert,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          Certification{" "}
          {cert !== null && cert !== undefined ? "Edit" : "Create"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <CertCreation
            cert={cert}
            certList={certList}
            onComplete={(c) => {
              if (updateCert !== null && updateCert !== undefined)
                updateCert(c);
              close();
            }}
            close={close}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CertificationCreateUpdateModal;
